import React, { useEffect } from "react";
import "./bloghome.css";
import Navbar from "../../../components/Navbar/Navbar";
import Blacknavtop from "../../../components/Navbar/Blacknavtop";
import Footer from "../../../components/footer/main";
import Fade from "@material-ui/core/Fade";
import Aos from "aos";
import "aos/dist/aos.css";
import Axios from "axios";
import { apiURL } from "../../../keys.js";
// import { Link } from "react-router-dom";
import { useState } from "react";
import BlogHomeCard from "../../../components/Cards/blogcard";
import TopicList from "../../../components/topiclist/topiclist";
import Skeleton from "react-loading-skeleton";

const HeaderBlogCard = (props) => {
  // console.log(props);
  return (
    <div data-aos="zoom-in">
      <div>
        {props.blog.image ? (
          <img src={props.blog.image} width="100%" />
        ) : (
          <img
            src="https://www.independentmediators.co.uk/wp-content/uploads/2016/02/placeholder-image.jpg"
            width="100%"
          />
        )}
      </div>
      <div>
        <img
          className="mainhead_blog_user_image"
          src="https://avatars3.githubusercontent.com/u/31445077?s=460&u=59bc6f20786c76032b87bab0abad5e341c4d5489&v=4"
          width="50px"
        />
        <div className="d-flex">
          {props.blog.category.map((cats) => {
            return (
              <p className="ml_2px tblue mb_0 mt_1 blog_topic" style={{ paddingTop: "4px" }}>
                {cats.toUpperCase()}
              </p>
            );
          })}
        </div>

        <a
          href={`/blog/${props.blog.slug}`}
          style={{ textDecoration: "none" }}
          className="blog_linker"
        >
          <h1 className="fbold">{props.blog.title}</h1>
        </a>
        <p>By Rupansh Kapoor</p>
        <p className="fs08 tgrey">
          <i className="fas fa-clock"></i> 23rd May, 2020, <i class="fas fa-eye"></i>{" "}
          {props.blog.readBy} views
        </p>
      </div>
    </div>
  );
};

const HeaderMiniList = (props) => {
  return (
    <div>
      {/* <p className="mb_0 tblue fbold"></p> */}
      <div className="d-flex">
        {props.blog.category.map((cats) => {
          return (
            <a href={`/category/${cats}`}>
              <p className="mb_0 fs14 ml_2px tblue fbold">
                {cats.toUpperCase()} {"     "}
              </p>
            </a>
          );
        })}
      </div>
      <a style={{ textDecoration: "none", color: "black" }} href={`/blog/${props.blog.slug}`}>
        <p className="fs12 tblack fontfam">{props.blog.title}</p>
      </a>
    </div>
  );
};

const Bloghome = () => {
  const [blogs, setBlogs] = useState([]);
  const [trends, setTrends] = useState([]);
  const [main, setMain] = useState([]);
  const [toptwo, setToptwo] = useState([]);
  const [trendloading, setTrendloading] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.get(`${apiURL}/blogs/view`).then((data) => {
      console.log(data);
      // setBlogs(data.data.data);
      // setTrends(data.data.data.slice)
      setMain(data.data.data[0]);
      setToptwo(data.data.data.slice(1, 3));
      if (data.data.data.length > 3) {
        setBlogs(data.data.data.slice(3, data.data.data.length));
      }
      setLoading(false);
    });

    Axios.get(`${apiURL}/blogs/trends`).then((data) => {
      setTrends(data.data.data);
      setTrendloading(false);
    });
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg_smoke">
      <Blacknavtop />
      <Navbar />
      <br />
      <div className="container mt_10rem mb_6rem">
        <div className="row">
          {/* <div className="col-1"></div> */}
          <Fade in={true}>
            <div className="col-lg-6 col-xs-12">
              {loading ? (
                <div className="loadingheaderdiv">
                  <div className="loadingheaderimg"></div>
                  <Skeleton style={{ width: "35%" }} />
                  <h1>
                    <Skeleton />
                  </h1>
                  <p>
                    <Skeleton style={{ width: "30%" }} />
                  </p>
                  <p>
                    <Skeleton style={{ width: "40%" }} />
                  </p>
                </div>
              ) : (
                <HeaderBlogCard key="1" blog={main} />
              )}
              {/* <HeaderBlogCard blog={main} /> */}
            </div>
          </Fade>
          <Fade in={true}>
            <div className="col-lg-6 col-xs-12">
              <div className="trend_div">
                <p className=" fs20px">
                  <i className="fas fa-poll"></i> TRENDS
                </p>
                {trendloading ? (
                  <>
                    <p>
                      <Skeleton style={{ width: "35%" }} />
                      <Skeleton />
                    </p>
                    <p>
                      <Skeleton style={{ width: "35%" }} />
                      <Skeleton />
                    </p>
                    <p>
                      <Skeleton style={{ width: "35%" }} />
                      <Skeleton />
                    </p>
                    <p>
                      <Skeleton style={{ width: "35%" }} />
                      <Skeleton />
                    </p>
                    <p>
                      <Skeleton style={{ width: "35%" }} />
                      <Skeleton />
                    </p>
                  </>
                ) : (
                  <>
                    {trends.map((trend, id) => (
                      <HeaderMiniList key={id} blog={trend} />
                    ))}
                  </>
                )}
              </div>
            </div>
          </Fade>
        </div>
      </div>
      <div className="container">
        {loading && toptwo.length == 0 ? (
          <>
            <LoadingBlog />
            <LoadingBlog />
          </>
        ) : (
          <>
            {toptwo.map((blogs, id) => (
              <BlogHomeCard key={id} blog={blogs} />
            ))}
          </>
        )}

        <TopicList />
        {loading && blogs.length == 0 ? (
          <>
            <LoadingBlog />
            <LoadingBlog />
          </>
        ) : (
          <>
            {console.log(blogs)}
            {blogs.map((blogs, id) => (
              <BlogHomeCard key={id + 2} blog={blogs} />
            ))}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

const LoadingBlog = () => {
  return (
    <div className="row mb_2rem bg_white">
      <div className="col-lg-4 col-xs-12 bg_smoke">
        <div></div>
      </div>
      <div className="col-lg-8 col-xs-12 ">
        <Skeleton style={{ width: "35%" }} />
        <h1>
          <Skeleton />
        </h1>
        <p>
          <Skeleton style={{ width: "30%" }} />
        </p>
        <p>
          <Skeleton style={{ width: "40%" }} />
        </p>
      </div>
    </div>
  );
};

export default Bloghome;
